export default "__VITE_ASSET__B3IdU_oh__"